import { useEffect } from 'react'

import {
  CAT_ANALYTICS,
  SERVICE_ANALYTICS_STORAGE,
} from '@/config/cookieConsent'
import { GA_MEASUREMENT_ID } from '@/config/system'

type GoogleAnalyticsProps = {
  measurementId?: string
}

export const GoogleAnalytics = ({
  measurementId = GA_MEASUREMENT_ID,
}: GoogleAnalyticsProps) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const existingExternalScript = document.querySelector(
      `script[src*="gtag/js"][data-category="${CAT_ANALYTICS}"]`
    )

    if (existingExternalScript) {
      return
    }

    const externalScript = document.createElement('script')
    externalScript.async = true
    externalScript.type = 'text/plain' // Initially block the script from running, our consent management will allow it to run once consent is given
    externalScript.setAttribute('data-category', CAT_ANALYTICS)
    externalScript.setAttribute('data-service', SERVICE_ANALYTICS_STORAGE)
    externalScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`

    const inlineScript = document.createElement('script')
    inlineScript.type = 'text/plain' // Initially block the script from running
    inlineScript.setAttribute('data-category', CAT_ANALYTICS)
    inlineScript.setAttribute('data-service', SERVICE_ANALYTICS_STORAGE)
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `

    document.head.appendChild(externalScript)
    document.head.appendChild(inlineScript)
  }, [measurementId])

  return null
}
